import { countWords } from "../analysis-utils/countWords";
import { endsWithPeriod } from "../analysis-utils/endsWithPeriod";
import matcher from "../analysis-utils/findWords";
import { removeActionVerbs } from "../analysis-utils/removeActionVerbs";
import { removeSpellingMistakes } from "../analysis-utils/removeSpellingMistakes";
import {
  IndividualCertificatesAnalysis,
  ResumeCertificateAnalysis,
} from "../resume-analyse-types";

const analyseCertificates = (
  certificates: ResumeCertificateAnalysis
): ResumeCertificateAnalysis => {
  return {
    ...certificates,
    individualCertificatesAnalysis:
      certificates?.individualCertificatesAnalysis?.map(
        (individualCertificate) => {
          return analyseIndividualCertificate(individualCertificate);
        }
      ),
  };
};

const analyseIndividualCertificate = (
  individualCertificate: IndividualCertificatesAnalysis
): IndividualCertificatesAnalysis => {
  return {
    ...individualCertificate,
    descriptionAnalysis: individualCertificate?.descriptionAnalysis?.map(
      (description) => {
        return {
          ...description,
          analysis: {
            ...description?.analysis,
            // 1. Check and Remove Action Verbs that are not present in the Description
            actionVerbAnalysis: removeActionVerbs(
              description?.statement,
              description?.analysis?.actionVerbAnalysis
            ),
            // 2. Check and Remove Spelling Mistakes that are not present in the Description
            spellingMistakes: removeSpellingMistakes(
              description?.statement,
              description?.analysis?.spellingMistakes
            ),
            // 3. Find the Buzz Words that are present in the Description using the buzz words JSON.
            buzzWords: matcher.search(description?.statement),
            // 4. Find the Filler Words that are present in the profile summary using the filler words JSON.
            fillerWords: matcher.search(description?.statement),
            // 5. Check if the Description ends with a period.
            endsWithPeriod: endsWithPeriod(description?.statement),
            //6. Count the number of words in the description
            bulletPointWords: countWords(description?.statement),
          },
        };
      }
    ),
  };
};

export { analyseCertificates };
